import { Link, type LinkProps } from "react-router-dom";
import { cn } from "@/lib/utils";

type Variant = "primary" | "ghost";

interface Props extends Omit<LinkProps, "to"> {
  variant?: Variant;
  label?: string;
  className?: string;
  to?: string;
}

export default function ApplyCTA({
  variant = "primary",
  label = "APPLY FOR A CALL",
  className,
  to = "/apply",
  ...rest
}: Props) {
  return (
    <Link
      to={to}
      className={cn(
        variant === "primary" ? "btn btn-primary" : "btn btn-secondary",
        className,
      )}
      {...rest}
    >
      {label}
      <span aria-hidden>→</span>
    </Link>
  );
}
